import { Injectable } from '@angular/core';
import { ToastController } from '@ionic/angular/standalone';

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  constructor(private toastController: ToastController) {}

  async presentToast(message: string) {
    const toast = await this.toastController.create({
      message: message,
      color: 'secondary',
      animated: true,
      cssClass: 'toastTop',
      position: 'middle',
      duration: 3000,
    });
    toast.present();
  }

  async presentWarningToast(message: string) {
    const toast = await this.toastController.create({
      message: message,
      color: 'warning',
      animated: true,
      position: 'middle',
      duration: 3000,
    });
    toast.present();
  }

  async presentToastWithOptions(header: string, message: string, color: string, cssClass: string) {
    const toast = await this.toastController.create({
      header: header,
      message: message,
      color: color,
      icon: 'alert',
      animated: true,
      position: 'middle',
      keyboardClose: true,
      cssClass: cssClass,
      buttons: [
        {
          side: 'end',
          icon: 'checkmark-outline',
          role: 'success',
          handler: () => {},
        },
        {
          icon: 'close-outline',
          side: 'end',
          role: 'cancel',
          handler: () => {},
        },
      ],
    });
    await toast.present();

    return await toast.onDidDismiss();
  }

  public async presentToastWithCustomButtons(
    header: string,
    message: string,
    color: string,
    cssClass: string,
    successBtnTxt: string,
    cancelBtnTxt: string,
  ) {
    const toast = await this.toastController.create({
      header: header,
      message: message,
      color: color,
      icon: 'alert',
      animated: true,
      position: 'middle',
      keyboardClose: true,
      cssClass: cssClass,
      buttons: [
        {
          text: successBtnTxt,
          role: 'success',
          handler: () => {},
        },
        {
          text: cancelBtnTxt,
          role: 'cancel',
          handler: () => {},
        },
      ],
    });
    await toast.present();

    return await toast.onDidDismiss();
  }
}
